export function initJetWin(app) {
	let appId;

	const service = {
		updateConfig(config){
			const appView = app.getRoot();
			const appNode = appView.$view;

			if(!appId){
				if(appNode.id)
					appId = appNode.id;
				else 
					appNode.id = appId = "webix_" + webix.uid();

				webix.html.addStyle(`.webix_win_inside *:not(.webix_modal_box):not(.webix_modal_cover){ z-index: 0; }`);
				webix.html.addStyle(`#${appId}{ position: relative; }`);
				webix.html.addStyle(`#${appId} .webix_window{ z-index:2 !important; }`);
				webix.html.addStyle(`#${appId} .webix_disabled{ z-index:1 !important; }`);
			}
			else if(appId && !appNode.id) //app refresh
				appNode.id = appId;

			config.container = appId;

			if(config.fullscreen){
				config._fillApp = true;
				delete config.fullscreen;
			}

			if(!config.on)
				config.on = {};

			let firstShow = true;
			const defaultHandler = config.on.onShow;

			config.on.onShow = function(){
				if(defaultHandler)
					defaultHandler.apply(this, arguments);

				if(firstShow){
					this.$setSize = (x, y) => {
						setSize(this, appView, true);
						webix.ui.window.prototype.$setSize.apply(this, [x, y]);
					};
					setHandlers(this, app);
					firstShow = null;
				}

				webix.callEvent("onClick", []);
				webix.html.addCss(appNode, "webix_win_inside");
				appView.disable();

				setSize(this, appView);
			}

			return config;
		}
	};

	app.setService("jet-win", service);
}

function setSize(win, appView, silent){
	const appWidth = appView.$width;
	const appHeight = appView.$height;

	if(win.config._fillApp)
		win.define({
			width: appWidth,
			height: appHeight,
		});
	else {
		win.define({
			left: (appWidth - win.$width) / 2,
			top: (appHeight - win.$height) / 2,
		});
	}

	if(!silent)
		win.resize();
}

function setHandlers(win, app){
	const appView = app.getRoot();

	win.attachEvent("onHide", ()=> {
		if(!appView.$destructed){
			webix.html.removeCss(appView.$view, "webix_win_inside");
			appView.enable();
		}
	});

	const resizeEv = app.attachEvent("view:resize", ()=> {
		setSize(win, appView);
	});

	win.attachEvent("onDestruct", ()=> {
		app.detachEvent(resizeEv);
	});
}
